export default __webpack_public_path__ + "static/media/whatsapp.458080b0.svg";